export const POS_CR_LOADING = "POS_CR_LOADING";
export const POS_CR_SESSION = "POS_CR_SESSION";
export const POS_CR_TRANSACTIONS = "POS_CR_TRANSACTIONS";
export const POS_CR_LAST_Z = "POS_CR_LAST_Z";
export const POS_CR_ERROR = "POS_CR_ERROR";
